export function formatJobMessage(raw: string | null | undefined) {
  const original = raw || '—';
  const progress = original.match(/\[(\d+)\/(\d+)\]/);
  const mapping = original.match(/^Mapping transaction - (.*?) \[\d+\/\d+\]/);
  const counts = [...original.matchAll(/\b([A-Z][A-Z_]+)\s*[:=]\s*(\d+)\b/g)].map(match => ({
    status: match[1],
    count: Number(match[2])
  }));
  let summary = original;
  let summaryKey = '';
  if (mapping) {
    summary = '';
    summaryKey = 'JOB_MESSAGE_MAPPING';
  } else if (counts.length) {
    summary = original
      .slice(0, original.indexOf(counts[0].status))
      .replace(/Bad or unknown mapping statuses:\s*$/, '')
      .replace(/[\s{,:-]+$/, '')
      .replace(/ - /g, ' · ');
    if (/^Mapped Transactions/.test(summary)) {
      summary = '';
      summaryKey = 'JOB_MESSAGE_MAPPING_FINISHED';
    }
  } else {
    summary = original.replace(/\. Execution report: .+$/, '');
  }
  const current = progress ? Number(progress[1]) : null;
  const total = progress ? Number(progress[2]) : null;
  return {
    original,
    summary,
    summaryKey,
    counts,
    current,
    total,
    percent: current !== null && total && total > 0 ? Math.min(100, (current / total) * 100) : null,
    formatted: !!mapping || counts.length > 0 || summary !== original
  };
}

export function formatJobDuration(milliseconds: number | null | undefined): string {
  if (milliseconds == null || !Number.isFinite(milliseconds) || milliseconds < 0) return '—';
  if (milliseconds < 1000) return '< 1s';
  const seconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return [hours ? `${hours}h` : '', minutes ? `${minutes}m` : '', `${seconds % 60}s`].filter(Boolean).join(' ');
}
